export const SOCIAL_MEDIA = [
  {
    name: "Instagram",
    icon: "instagram",
    url: "https://www.instagram.com/shrigarofficial"
  },
  {
    name: "Facebook",
    icon: "facebook",
    url: "https://www.facebook.com/shrigarofficial"
  },
  {
    name: "Pinterest",
    icon: "pinterest",
    url: "https://www.pinterest.com/shrigar"
  },
  {
    name: "YouTube",
    icon: "youtube",
    url: "https://www.youtube.com/@shrigar"
  }
];

export const FOOTER_LINKS = {
  company: [
    { label: "About Us", path: "/AboutUs" },
    { label: "Contact Us", path: "/ContactUs" },
    { label: "Careers", path: "/Careers" }
  ],
  support: [
    { label: "FAQs", path: "/faqs" },
    { label: "Shipping & Returns", path: "/shipping" },
    { label: "Privacy Policy", path: "/privacy-policy" }
  ],
  legal: [
    { label: "Terms & Conditions", path: "/terms" },
    { label: "Refund Policy", path: "/refund-policy" }
  ]
};

export const CONTACT_INFO = {
  email: "support@shrigar.com",
  phone: "+91 98765 43210",
  address: "Mumbai, Maharashtra, India"
};
